// extracted by mini-css-extract-plugin
export default {"no_results_container":"ResourceBrowserSearchResults_no_results_container__Ehk3y"};